var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFlecha(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 151.3 114.57",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142.4 46.79h-110L67 15.51A8.9 8.9 0 1055.1 2.29L4.7 47.85l-.32.15a3.85 3.85 0 00-.38.23l-.37.26-.33.25c-.14.11-.27.23-.4.35l-.22.2-.39.42L2 50c-.11.13-.21.28-.31.42a7.67 7.67 0 00-.52.79l-.14.22c-.07.14-.14.29-.2.43l-.18.36c0 .12-.08.24-.13.36s-.12.31-.16.46l-.06.21a7.9 7.9 0 00-.21 1c0 .16-.06.33-.08.5s0 .2 0 .3v.59H0A2.83 2.83 0 000 56v.53c0 .17 0 .28.06.42s0 .3.07.44a3.48 3.48 0 00.1.44c0 .14.06.27.1.41s.09.28.14.42l.15.4.18.4c.06.13.12.26.19.39l.21.37c.08.13.15.26.23.38l.27.37.25.33c.11.14.23.27.35.4l.2.23 48.69 50a8.9 8.9 0 0012.58.14A8.9 8.9 0 0064 99.45L30 64.59h112.4a8.9 8.9 0 008.9-8.9 8.91 8.91 0 00-8.9-8.9z",
    fill: "#52d1de",
    "data-name": "Capa 2"
  })));
}

export default SvgFlecha;